import { render } from "./SectionAccountProfile.vue?vue&type=template&id=5f700a20&scoped=true"
import script from "./SectionAccountProfile.vue?vue&type=script&lang=js"
export * from "./SectionAccountProfile.vue?vue&type=script&lang=js"

import "./SectionAccountProfile.vue?vue&type=style&index=0&id=5f700a20&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f700a20"]])

export default __exports__